import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import React, {Suspense} from 'react';
import Header from '@di-shared/features/common/Header';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {ErrorBoundary} from 'react-error-boundary';
import SafeDrivingReportEu from '@di-shared/features/safe-driving/eu/report/SafeDrivingReport.eu';

export interface SafeDrivingReportPageProps {
  vin: string;
}

function SafeDrivingReportPage({vin}: SafeDrivingReportPageProps) {
  const {t} = useInferableTranslation();

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('ctn_dss_LN_driving_safety_report')}</h1>
      </Header>
      <ErrorBoundary fallback={<SafeDrivingReportEu.Error vin={vin} />}>
        <Suspense fallback={<SafeDrivingReportEu.Loading />}>
          <SafeDrivingReportEu vin={vin} />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}

export default SafeDrivingReportPage;
